import { entityConfigToType, InfraType } from 'app/agriculture/mutations/types/entityConfig';

export function getPlaceholderName<T extends InfraType>({
    infraType,
    entities,
}: {
    infraType: T;
    entities: Map<entityConfigToType[T]['id'], entityConfigToType[T]>;
}) {
    // Calculate initial position number
    // If creating a new entity, start at otherEntities.length + 1
    let position = entities.size + 1;

    // Create initial placeholder name
    let result = `${infraType} ${position}`;

    while ([...entities.values()].some(({ name }) => name.includes(result))) {
        position++;
        result = `${infraType} ${position}`;
    }

    return result;
}
